export default "__VITE_ASSET__c868f05c__"